import ArrowLeftIcon from "assets/icons/ArrowLeftIcon";
// import LanguagePicker from "components/LanguagePicker";
import { useLifeChoicePageContext } from "context/hooks/useLifeChoicePageContext";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { useAppSelector } from "store/hooks";
import { getSettings } from "store/slices";
import { ILifeChoiceTabs } from "types/context/lifeChoicePage";
import UserSection from "components/Header/UserSection";
import Loader from "components/Loader";
import { useEffect } from "react";

import { Link } from "react-router-dom";
import Label from "components/common/Label";

const FirstScreen = () => {
  const { tabHandler, lifeChoice, activeTab } = useLifeChoicePageContext();
  const { dir, language, tenant } = useAppSelector(getSettings);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { id } = useParams();

  useEffect(() => {
    tabHandler(ILifeChoiceTabs.OVERVIEW);
    window.scrollTo(0, 0);
  }, [id]);

  if (!language) {
    return <Loader open={true} />;
  }
  return (
    <section className={"bg-theme-purple bg-opacity-75 relative"}>
      <div className={`pt-8 flex flex-col gap-12 container`}>
        <img
          src={lifeChoice?.cover_image}
          className={
            "absolute inset-0 h-full w-full object-cover object-center z-[-1]"
          }
        />
        <div className={"flex justify-between"} dir={dir}>
          <div className={"flex items-center gap-3"}>
            <ArrowLeftIcon
              onClick={() => navigate("/")}
              className={`cursor-pointer ${dir === "rtl" ? "rotate-180" : ""}`}
            />
            <Link to="/">
              <h1 className={"text-theme-blue text-3xl font-heebo"}>nexme</h1>
            </Link>
          </div>
          <div>
            <div className="flex items-center gap-4">
              {/* <LanguagePicker color="white" /> */}
              <UserSection color={"white"} />
            </div>
          </div>
        </div>
        <div>
          <Label
            className={
              "text-3xl lg:text-4xl font-black text-white tracking-wide rtl:float-end ltr:float-start font-heebo"
            }
            lang={language}
            dir={dir}
          >
            {lifeChoice?.title?.[language]}
          </Label>
          <p
            className="text-lg text-white mt-1 hidden md:block rtl:text-right ltr:text-left"
            lang={language}
            dir={dir}
          >
            {lifeChoice?.subTitle?.[language]}
          </p>
        </div>
        <div
          lang={language}
          dir={dir}
          className="flex items-center justify-between"
        >
          <div
            className={
              "flex items-center justify-start max-w-[min(100vw,768px)] w-full"
            }
            lang={language}
            dir={dir}
          >
            {Object.values(ILifeChoiceTabs).map((tab, idx) => (
              <button
                key={`--tab-${tab}-${idx}`}
                onClick={() => tabHandler(tab)}
                className={`text-white w-1/4 pt-4 pb-2 border-b-[5px] transition-all duration-500 text-sm lg:text-xl font-heebo ${
                  activeTab === tab
                    ? "bg-white bg-opacity-30 border-b-white"
                    : tab === "apply"
                    ? "bg-theme-yellow bg-opacity-50"
                    : "bg-transparent border-b-theme-blue"
                }`}
              >
                {tenant.tabs_title[tab] || t(tab)}
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FirstScreen;
